import type { FC } from 'react'
import { ImageSwiperViewProps } from '../../types'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination, Navigation, Autoplay } from 'swiper/modules'
import SwiperCore from 'swiper'
import 'swiper/css/bundle'
import 'swiper/css/navigation'
import { Box } from '@mui/material'
import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material'

SwiperCore.use([Pagination, Navigation, Autoplay])

export const ImageSwiperView: FC<ImageSwiperViewProps> = (props) => {
    const {
        onAutoplayTimeLeft,
        dynamicImages,
        progressCircle,
        progressContent,
        dynamicSiteData,
        timeLeft,
        setTimeLeft,
    } = props

    return timeLeft !== undefined ? (
        <Box
            className='relative w-4/5'
            data-testid='ImageSwiper'
        >
            <Swiper
                className='ml-0'
                modules={[Autoplay, Navigation, Pagination]}
                navigation={{
                    nextEl: '.image-swiper-button-next',
                    prevEl: '.image-swiper-button-prev',
                    disabledClass:
                        'swiper-button-disabled cursor-not-allowed text-gray-400',
                }}
                pagination={{ clickable: true }}
                autoplay={{
                    delay: timeLeft || 4500,
                    disableOnInteraction: false,
                }}
                onAutoplayTimeLeft={onAutoplayTimeLeft}
                loop
                grabCursor
                style={{
                    ['--swiper-navigation-color' as string]: '#ffcf00',
                    ['--swiper-pagination-color' as string]: '#ffcf00',
                }}
            >
                {dynamicImages?.queryResults?.map((image, index) =>
                    !!image ? (
                        <SwiperSlide
                            key={index}
                            className='rounded-md overflow-hidden'
                        >
                            {({ isActive }) => {
                                if (isActive) {
                                    setTimeLeft(
                                        dynamicSiteData?.images?.[index]
                                            ?.seconds
                                            ? dynamicSiteData?.images?.[index]
                                                  ?.seconds * 1000
                                            : 4500,
                                    )
                                }
                                return (
                                    <>
                                        <h3 className='text-pantone-gray-2'>
                                            {
                                                dynamicSiteData?.images?.[index]
                                                    .title
                                            }
                                        </h3>
                                        <img
                                            key={index}
                                            className='w-full h-full max-h-[305px] object-cover rounded-md overflow-hidden'
                                            src={image.data}
                                            alt={`dynamic slide ${index + 1}}`}
                                        />
                                    </>
                                )
                            }}
                        </SwiperSlide>
                    ) : null,
                )}
                {dynamicImages?.queryResults &&
                    Number(dynamicImages?.queryResults?.length) > 1 && (
                        <div
                            className='absolute right-4 bottom-4 z-10 w-12 h-12 flex items-center justify-center font-bold text-pantone-yellow'
                            slot='container-end'
                        >
                            <svg
                                viewBox='0 0 48 48'
                                ref={progressCircle}
                                className='absolute left-0 top-0 z-10 w-full h-full stroke-[4px] stroke-pantone-yellow fill-none -rotate-90'
                                style={{
                                    ['--progress' as string]: 0,
                                    strokeDashoffset:
                                        'calc(125.6 * (1 - var(--progress)))',
                                    strokeDasharray: '125.6',
                                }}
                            >
                                <circle
                                    cx='24'
                                    cy='24'
                                    r='20'
                                ></circle>
                            </svg>
                            <span ref={progressContent}></span>
                        </div>
                    )}
            </Swiper>
            {dynamicImages?.queryResults &&
                Number(dynamicImages?.queryResults?.length) > 1 && (
                    <>
                        <div className='swiper-button absolute right-0 pr-4 cursor-pointer text-pantone-yellow top-16 bottom-0 flex flex-col justify-center my-auto z-20 image-swiper-button-next'>
                            <ArrowForwardIos />
                        </div>
                        <div className='swiper-button absolute left-0 pl-4 cursor-pointer text-pantone-yellow top-16 bottom-0 flex flex-col justify-center my-auto z-20 image-swiper-button-prev'>
                            <ArrowBackIos />
                        </div>
                    </>
                )}
        </Box>
    ) : null
}
